import type { ElementType, ReactNode } from "react";
import { cn } from "../../lib/cn";

interface GlassCardProps {
  as?: ElementType;
  className?: string;
  strong?: boolean;
  subtle?: boolean;
  padded?: boolean;
  children?: ReactNode;
  [key: string]: any;
}

export function GlassCard({
  as: As = "div",
  className,
  strong,
  subtle,
  padded = true,
  children,
  ...rest
}: GlassCardProps) {
  const surface = strong ? "glass-strong" : subtle ? "glass-subtle" : "glass";
  return (
    <As
      className={cn(
        surface,
        "rounded-3xl relative overflow-hidden",
        padded && "p-5",
        className,
      )}
      {...rest}
    >
      {/* Top inner highlight (Apple glass hallmark) */}
      <span
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"
      />
      {children}
    </As>
  );
}
